import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import logo from "./logo.png";
import DateTime from "./DateTime";
import Info from "./Info";
import Settings from "./Settings";
import Download from "./Download";
import Contact from "./Contact";
import Summary from "./Summary";

function NavBar({
  wallet,
  total,
  setWallet,
  fees,
  setFees,
  vat,
  setVat,
  handleWallet,
  buyingList,
  setBuyingLists,
}) {
  return (
    <header>
      <div className="text-center">
        <p className=" text-danger m-0 p-1">
          نسخة للتجربة فقط وللتعرف على طريقة استخدام التطبيق. يمكنك الحذف
          والتعديل والاضافة وعند تحديث الصفحة سيتم اعادة البيانات السابقة
          <br></br>
          <p className="m-0 p-0 text-dark">
            للبدء في استخدام التطبيق يرجى زيارة الرابط التالي :{" "}
            <a target="_blank" rel="noreferrer" href="https://as-homi.com">
              www.as-homi.com
            </a>
          </p>
        </p>
      </div>
      <div className="container-fluid text-light bg-dark p-1 m-0 d-flex d-sm-flex flex-sm-row align-items-center justify-content-between">
        <DateTime />
        <small className="d-none d-lg-flex align-items-center  justify-contents-center">
          لا إله إلا الله وحده لا شريك له، له الملك وله الحمد يحيي ويميت، وهو حي
          لا يموت، بيده الخير وهو على كل شيءٍ قدير
        </small>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <Settings
              buyingList={buyingList}
              setBuyingLists={setBuyingLists}
              wallet={wallet}
              setWallet={setWallet}
              fees={fees}
              setFees={setFees}
              vat={vat}
              setVat={setVat}
              handleWallet={handleWallet}
            />
          </div>
          <div className=" mr-2">
            <Summary buyingList={buyingList} wallet={wallet} total={total} />
          </div>
          <div className=" mr-2">
            <Download buyingList={buyingList} setBuyingLists={setBuyingLists} />
          </div>
          <div className=" mr-2">
            <Contact />
          </div>
          <div className=" mr-2">
            <Info />
          </div>
        </div>
      </div>
      <div className="wrap">
        <div className="logo p-2">
          <img src={logo} alt="logo"></img>
        </div>
      </div>
    </header>
  );
}

export default NavBar;
